const gradeInfo = [
    { name: "Excepcional", number: 1, description: "Riesgo extremadamente bajo" },
    { name: "Muy sólido", number: 2, description: "Riesgo muy bajo" },
    { name: "Sólido", number: 3, description: "Riesgo bajo" },
    { name: "Bueno", number: 4, description: "Riesgo inferior a la media" },
    { name: "Medio", number: 5, description: "Riesgo medio" },
    { name: "Precaución", number: 6, description: "Riesgo superior a la media" },
    { name: "Débil", number: 7, description: "Riesgo confirmado" },
    { name: "Muy débil", number: 8, description: "Riesgo elevado" },
    { name: "En dificultades", number: 9, description: "Riesgo muy elevado" },
    { name: "Fallido", number: 10, description: "Pérdida" }

];

export const gradeToText = gradeNumber => {
    return gradeNumber != null ? gradeInfo.filter(g => g.number === gradeNumber)[0].name : "";
}

export const gradeToDescription = gradeNumber => {
    return gradeNumber != null ? gradeInfo.filter(g => g.number === gradeNumber)[0].description : "";
}

export const debtorGradeStatusToText = debtorGradeStatus => {
    return debtorGradeStatus === "active" ? "En vigor" : "Expirado";
}